import React from 'react';

import SectionContainer from 'components/sectionContainer';
import LearnMore from 'components/learnMore';
import { Title } from 'components/typography';

import {
  missionContainer,
  missionIntro,
  missionAndVisionDescription,
  imageContainer,
  learnMore,
  columnTitle,
} from './scss/Mission.module.scss';

const Mission = () => {
  return (
    <div className={missionContainer}>
      <SectionContainer className={missionIntro}>
        <Title
          size="xl"
          value={
            <span>
              {'we are creating opportunities for'}
              <br className="d-none d-md-block" />
              {' everyone in the commodities ecosystem'}
            </span>
          }
        />
        <LearnMore
          className={learnMore}
          context="OUR PRODUCT & SERVICES"
          href="/big-data-analytics"
        />
      </SectionContainer>
      <div className={missionAndVisionDescription}>
        <div className={imageContainer} />
        <div>
          <Title
            className={columnTitle}
            fontStyle="regular"
            value="Mission"
            size="xs"
          />
          <p>
            {`
              Creating the right incentives and a shared platform to 
              change the food systems in Africa - making them more inclusive, 
              scalable and efficient, with shared prosperity and trust embedded. 
            `}
          </p>
        </div>

        <div>
          <Title
            className={columnTitle}
            fontStyle="regular"
            value="Vision"
            size="xs"
          />
          <p>{`Co-creating solutions to help Africa feed itself`}</p>
        </div>
      </div>
    </div>
  );
};

export default Mission;
